module.exports = __webpack_public_path__ + "img/characters_Tommy.60f29f24.png";